<template>
  <div>
    <div class="guest-photo">
      <div v-if="isCurrentUser(person)" class="edit-profile">
        <a href="javascript:void(0);" @click="openPopUp()" class="edit"
          ><i class="fa fa-fw fa-lg fa-pencil" aria-hidden="true"></i
        ></a>
      </div>
      <div
        class="image"
        :class="[online ? 'user_in' : 'user_out', bannedClass]"
        :style="{ 'background-image': backgroundImage }"
      >
        <div v-if="!photo" class="initials">{{ initials }}</div>
        <div v-if="isInConnections(person.userUUID, userConnectionsStatuses.ACTIVE)" class="user-connected">
          <span class="net-label">Contacts</span><i class="ar-icon icon-check-circle-light" aria-hidden="true"></i>
        </div>
        <div class="presence" :class="person.isOnline ? 'user_in' : 'user_out'"></div>
      </div>
    </div>
    <div class="guest-name">
      <div class="name">{{ fullname }}</div>
      <div v-if="jobtitle" class="title">{{ jobtitle }}</div>
      <div v-if="company" class="company">{{ company }}</div>
    </div>
    <div class="guest-social">
      <div v-if="linkedin" class="social-ico">
        <a :href="linkedin" target="_blank"><i aria-hidden="true" class="fa fa-linkedin-square"></i></a>
      </div>
      <div v-if="twitter" class="social-ico">
        <a :href="twitter" target="_blank"><i aria-hidden="true" class="fa fa-twitter-square"></i></a>
      </div>
      <div v-if="facebook" class="social-ico">
        <a :href="facebook" target="_blank"><i aria-hidden="true" class="fa fa-facebook-square"></i></a>
      </div>
    </div>
    <div class="event-meta">
      <div v-if="showActions" class="popover-actions">
        <template v-if="!activeRoom.ROOM_CHAT_DISABLED">
          <div v-if="user.is_admin || (currentUser && isDomainAdmin(currentUser.emailDomain))" class="action">
            <a @click="banPerson()" href="javascript:void(0);">
              <span class="ico"><i class="clickable ar-icon icon-comment-alt-light-ban"></i></span>
              <span v-if="isBanned" class="action-text">Restore user</span>
              <span v-else class="action-text">Ban from Room chat</span>
            </a>
          </div>
        </template>
        <div v-if="currentUserPermissions.canNetwork && permissions.canPrivateChat" class="action">
          <a @click="sendPrivateMessage(person, true)" href="javascript:void(0);">
            <div class="ico"><i class="clickable ar-icon icon-comment-alt-light"></i></div>
            <div class="action-text">Send Message</div>
          </a>
        </div>

        <div v-if="currentUserPermissions.canNetwork && isNetworkingEnabledForUser(person)" class="action">
          <template v-if="canUserSendVideoCallInvites(person)">
            <a @click="createVideoCallInvite(person.userUUID)" href="javascript:void(0);">
              <div
                class="ico"
                :class="{ user_busy: person.mediaDeviceStatus === mediaDeviceStatuses.BUSY }"
                :title="
                  person.mediaDeviceStatus === mediaDeviceStatuses.ALLOW
                    ? 'Available to chat'
                    : person.mediaDeviceStatus === mediaDeviceStatuses.BUSY
                    ? 'Busy on a call'
                    : 'Not available'
                "
              >
                <i class="ar-icon icon-video-light"></i>
              </div>
              <div class="action-text">
                {{ $store.state.videoChat.activeVideoChat ? "Add to call" : "Video call" }}
              </div>
            </a>
          </template>
          <template v-else>
            <div class="ico user_out" title="Not available"><i class="ar-icon icon-video-light"></i></div>
            <div class="action-text">Video call</div>
          </template>
        </div>

        <template v-if="currentUserPermissions.canNetwork && isNetworkingEnabledForUser(person)">
          <div
            v-if="
              !isInConnections(person.userUUID) || isInConnections(person.userUUID, userConnectionsStatuses.DELETED)
            "
            class="action"
          >
            <a @click="addToNetwork(person)" href="javascript:void(0);">
              <div class="ico"><i class="clickable ar-icon icon-check-circle-light" aria-hidden="true"></i></div>
              <div class="action-text">Add to Contacts</div>
            </a>
          </div>
          <div class="action" v-else>
            <a
              v-if="isInConnections(person.userUUID, userConnectionsStatuses.ACTIVE)"
              @click="removeFromNetwork(person)"
              href="javascript:void(0);"
            >
              <div class="ico"><i class="clickable ar-icon icon-times-circle-light" aria-hidden="true"></i></div>
              <div class="action-text">Remove from Contacts</div>
            </a>
            <a v-else @click="restoreNetwork(person)" href="javascript:void(0);">
              <div class="ico"><i class="clickable ar-icon icon-check-circle-light" aria-hidden="true"></i></div>
              <div class="action-text">Contact restore</div>
            </a>
          </div>
        </template>

        <div v-if="canUserSendTableMovementInvites(person)" class="action">
          <template v-if="hasUserProcessingInvites">
            <div class="ico"><i class="ar-icon icon-ico_user_in"></i></div>
            <div class="action-text">Invite sent...</div>
          </template>
          <template v-else>
            <!-- TODO: add condition Only for current room (otherwise disabled) -->
            <a @click="createTableMovementInvite(person.userUUID)" href="javascript:void(0);">
              <div class="ico"><i class="ar-icon icon-user-plus-light"></i></div>
              <div class="action-text">Invite to My {{ groupTerminology }}</div>
            </a>
          </template>
        </div>
      </div>
      <div v-if="table && !isSingleRoom" class="table-name">
        <div class="label">LOCATION</div>
        <div class="name">
          <span>{{ personRoomName }}</span>
        </div>
      </div>
      <div v-if="table" class="table-name">
        <div class="label">
          {{ groupTerminology.toUpperCase() }}
          NAME
        </div>
        <div class="name">
          <a href="javascript:void(0);" @click="scrollToTable(table.TABLE_UUID)">
            {{ table.TITLE }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonMixin from "@/components/DigitalEvent/RoomList/Room/mixins/PersonMixin";
import PersonActionsMixin from "@/components/DigitalEvent/RoomList/Room/mixins/PersonActionsMixin";
import InvitePermissionsMixin from "@/components/DigitalEvent/mixins/Permissions/InvitePermissionsMixin";
import VideoCallInviteMixin from "@/components/DigitalEvent/RoomList/Room/mixins/Invite/VideoCallInviteMixin";
import { INVITE_TYPES, TABLE_TYPES, MEDIA_DEVICE_STATUSES } from "@/helpers/constants";
import { mapGetters } from "vuex";

export default {
  name: "PersonPopover",
  mixins: [PersonMixin, PersonActionsMixin, InvitePermissionsMixin, VideoCallInviteMixin],
  props: {
    person: {
      type: Object,
      required: true,
      validator: function(value) {
        return value && value.profile;
      }
    },
    tableType: {
      type: String,
      required: false
    },
    isBanned: {
      type: Boolean,
      required: false
    },
    options: {
      type: Object,
      required: false,
      default: () => ({
        actions: true,
        presence: true,
        title: true,
        company: true,
        messagecount: false,
        showIsMe: false,
        avatarOnly: false
      })
    }
  },
  computed: {
    ...mapGetters({
      getUser: "users/getUser",
      currentUser: "users/currentUser",
      isDomainAdmin: "users/isDomainAdmin",
      groupTerminology: "room/groupTerminology",
      currentUserPermissions: "users/currentUserPermissions",
      activeRoom: "room/activeRoom",
      rooms: "room/rooms",
      isSingleRoom: "room/isSingleRoom"
    }),
    /**
     * Check that user has invite in SEND status
     * @return {Boolean}
     */
    hasUserProcessingInvites() {
      return this.$store.getters["invites/hasUserProcessingInvites"](INVITE_TYPES.TABLE_MOVEMENT, this.person.userUUID);
    },
    bannedClass() {
      return this.person.isBanned && this.isAdmin ? "banned" : "";
    },
    isAdmin() {
      return this.user.is_admin || this.isDomainAdmin(this.getUser(this.user.user_uuid).emailDomain);
    },
    /**
     * Media device statuses
     * @return {Object}
     */
    mediaDeviceStatuses() {
      return MEDIA_DEVICE_STATUSES;
    },
    personRoomName() {
      let personRoom = this.rooms.find(room => room.uuid === this.person.roomUUID);
      return personRoom.uuid === this.activeRoom.uuid ? `${personRoom.TITLE} (current)` : personRoom.TITLE;
    }
  },
  methods: {
    openPopUp() {
      let tabs = document.querySelector(".tabs-component");
      tabs.scrollIntoView({ block: "start", behavior: "smooth" });
      this.editProfile();
    },
    banPerson() {
      this.$emit("banUser");
    },
    /**
     * Check that networking enabled for current user
     * @param user {Object}
     * @return {boolean}
     */
    isNetworkingEnabledForUser(user) {
      let table = this.$store.getters["tables/tableByUser"](user);

      return (
        this.$store.getters["tables/userTable"].TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY &&
        table &&
        table.TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY
      );
    },
    /**
     * Create a new TableMovement invite
     * @param userUUID {String}
     * @return {Promise<void>}
     */
    async createTableMovementInvite(userUUID) {
      await this.$store.dispatch("invites/createTableMovementInvite", { userUUID });
    }
  }
};
</script>
